module.exports = __webpack_public_path__ + "img/exit.4d2b24bf.svg";